import React from 'react';

// Components
import {FormControl, InputLabel, MenuItem, Select, makeStyles} from '@material-ui/core';

// Libraries
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  selectStyles: {minWidth: theme.spacing(13)},
}));

const RenderSelectComponent = ({handleChange, value, optionsArray, className, name, label, startingValue}) => {
  const classes = useStyles();
  return (
    <FormControl className={className}>
      <InputLabel id={`${name}-select-label`}>{label || name}</InputLabel>
      <Select
        className={classes.selectStyles}
        id={`${name}-select`}
        labelId={`${name}-select-label`}
        name={name}
        value={value || startingValue}
        onChange={handleChange}
      >
        {optionsArray.map(searchOption => (
          <MenuItem key={searchOption.value} value={searchOption.value}>
            {searchOption.title}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

RenderSelectComponent.propTypes = {
  className: PropTypes.string,
  handleChange: PropTypes.func,
  label: PropTypes.string,
  name: PropTypes.string,
  optionsArray: PropTypes.array,
  startingValue: PropTypes.string,
  value: PropTypes.string,
};

export default RenderSelectComponent;
